import '../styles/PageGlobal.css';
import './DashboardParametresPage.css';
import React from "react";



export default function DashboardParametresPage() {
 

  return (
    <div  className="containerMain">
  <h1>Paramétres dashboard</h1>
  <p>Ceci est un contenu protégé</p>

  
</div>
  );
}